/** Offre Compte Prêt-à-Servir — prestation ponctuelle, pas l'abonnement Premium. */

export const CONFIG_OFFER_PRICE_EUR = 29;

export const CONFIG_OFFER_PRICE_LABEL = `${CONFIG_OFFER_PRICE_EUR}€ paiement unique`;

export const CONFIG_OFFER_BANNER_MESSAGE =
  'Configuration de ton compte : 29€ paiement unique (hors abonnement) + 1 semaine Premium offerte !';

export const CONFIG_OFFER_BUTTON_LABEL = 'On configure ton compte pour toi';

export const CONFIG_OFFER_LINK_LABEL = 'Compte Prêt-à-Servir';

export const CONFIG_OFFER_SEO_TITLE =
  'Compte Prêt-à-Servir | Aide à la configuration (29€ unique, hors abonnement)';

export const CONFIG_OFFER_SEO_DESCRIPTION =
  'Prestation de mise en place de ton compte Rintintin Pro (profil, services, planning, paiements) : 29€ paiement unique, hors abonnement. Abonnement Premium à partir de 15€/mois. Visio incluse + 1 semaine Premium offerte.';

export const CONFIG_OFFER_SUBSCRIPTION_DISCLAIMER =
  "Les 29€ sont une prestation de configuration ponctuelle, pas l'abonnement. L'abonnement Rintintin Pro reste gratuit (Essentiel) ou Premium à partir de 15€/mois (annuel) ou 20€/mois (mensuel).";

export const SUBSCRIPTION_PRICING_SUMMARY =
  'Essentiel gratuit · Premium 15€/mois (annuel) ou 20€/mois (mensuel) · 7 jours d\'essai';
